









import {
  computed,
  defineComponent,
  useContext,
  useRouter,
} from '@nuxtjs/composition-api';
import { SfBadge } from '@storefront-ui/vue';

import SvgImage from '~/components/General/SvgImage.vue';
import { useCart } from '~/composables';
import { useUser } from '~/modules/account/composables/useUser';

export default defineComponent({
  name: 'BottomCart',
  components: {
    SfBadge,
    SvgImage,
  },
  setup() {
    const { cart } = useCart();
    const { isAuthenticated } = useUser();
    const router = useRouter();
    const { app } = useContext();

    const goToCart = async () => {
      await router.push(app.localeRoute({ name: 'cart' }));
    };

    return {
      isAuthenticated,
      goToCart,
      cartTotalItems: computed(() => cart.value?.total_quantity),
    };
  },
});
